export const ALPHABET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('')

export const MODES = {
  QUICK_PLAY: "quickPlay",
  MELTDOWN: "meltdown",
  LECTURE: "lecture"
}

export const TASK_GROUP_TYPES = {
  TRIVIA: "TRIV",
  SCENARIO: "SCE"
}

export const TASK_TYPES = {
  MC: "MC",
  MCIA: "MCIA",
  MCV: "MCV",
  SEQ: "SEQ",
}

export const MODE_SPECS = {
  [MODES.MELTDOWN]: [
    {
      taskGroupType: [TASK_GROUP_TYPES.TRIVIA],
      taskCount: 7, // # of tasks per team
      // taskCount: 1, // for testing
      taskPointValue: 10,
      shuffleTasks: true,
    },
    {
      taskGroupType: [TASK_GROUP_TYPES.SCENARIO],
      taskCount: 5, // # of tasks per team
      // taskCount: 1, // for testing
      taskPointValue: 12,
      shuffleTasks: false,
    }
  ],
  [MODES.QUICK_PLAY]: [
    {
      taskGroupType: [TASK_GROUP_TYPES.SCENARIO],
      taskCount: 5, // # of tasks per team
      // taskCount: 1, // for testing
      taskPointValue: 12,
      shuffleTasks: true,
    }
  ],
  [MODES.LECTURE]: [
    {
      taskGroupType: [ TASK_GROUP_TYPES.TRIVIA, TASK_GROUP_TYPES.SCENARIO ],
      taskPointValue: 10,
      shuffleTasks: false,
    }
  ]
}

export const CATEGORIES_ORDER = ["RAS", "HAR", "TOX", "HDA", "PCT", "ROR", "CPP", "PPE", "DEC"];